// extracted by mini-css-extract-plugin
module.exports = {"root":"Overview_root__2OObi","tabs":"Overview_tabs__11FQR","infotab":"Overview_infotab__1jsoi","graphWrapper":"Overview_graphWrapper__36E6g","graph":"Overview_graph__3kRcU"};